<template>

  <div class="hardcodedHeightContainer">
    <v-tabs
        grow
        dark
        :slider-color="$colors.yellow"
        v-model="tab"
        :background-color="$colors.sky_blue_1"
    >
      <v-tab key="procedurelist">
        Step List
      </v-tab>
      <v-tab key="handbook">
        Handbook
      </v-tab>
    </v-tabs>

    <div v-if="tab===1" style="margin: 5px">
      <v-btn x-small @click="page--">
        <LATIcon icon="caret-left"/>
      </v-btn>

      Page {{ page }} of {{ numPages }}

      <v-btn x-small @click="page++">
        <LATIcon icon="caret-right"/>
      </v-btn>

      <div style="margin-left: 20px; display: inline-block">
        <v-btn x-small @click="zoom -= 10">
          <LATIcon icon="magnifying-glass-minus"/>
        </v-btn>

        <v-btn x-small @click="zoom += 10">
          <LATIcon icon="magnifying-glass-plus"/>
        </v-btn>
      </div>
    </div>

    <vue-scroll>

    <v-tabs-items v-model="tab" class="handbookwidthMinusTab">

      <v-tab-item key="procedurelist">

        <div v-if="procedure.steps.length === 0">

          <div style="margin-top: 25px">

            <v-img src="/graphics/dinner-for-one-butler-james.jpeg" height="50vh" contain />

            <span>Procedure does not exist in this prototype</span>
          </div>


        </div>

        <div v-else>

            <v-timeline
                align-top
                dense
            >
              <v-timeline-item
                  small
                  v-for="(step, stepIdx) in procedure.steps"
                  v-bind:key="stepIdx"
              >

                <template v-slot:icon>
                  <v-avatar
                      rounded
                      size="30"
                      style="color: white"
                      :color="selectedProcedureStep && selectedProcedureStep.stepIdx === stepIdx ? $colors.yellow : $colors.sky_blue_1"
                  >{{ stepIdx + 1 }}
                  </v-avatar>
                </template>

                <v-card style="margin-right: 16px; background: white" color="white">
                  <div>
                    {{ step.message }}
                  </div>
                  <div>
                    {{ step.todo }}
                  </div>
                </v-card>

              </v-timeline-item>

            </v-timeline>
        </div>

        <div style="margin-top: 100px">&nbsp;</div>

      </v-tab-item>


      <v-tab-item key="handbook">

          <pdf
              style="overflow:scroll;"
              class="pdfviewer" :src="handbookURL"
              ref="pdf" :style="`width: ${zoom}%`"
              :page="page"
              @progress="this.progress"
              @error="pdfError"
              @num-pages="numPages = $event"
              @link-clicked="page = $event"
          />

      </v-tab-item>

    </v-tabs-items>

    </vue-scroll>

  </div>

</template>

<script>
import pdf from 'vue-pdf'
import {aircraftConfig, settings} from "../config";
import LATIcon from "./Icon/LATIcon";
import {procedureTeacher} from "../modules/ProcedureTeacher";

export default {
  name: "Handbook",
  props: ["procedure"],
  components: {
    LATIcon,
    pdf
  },
  computed: {
    handbookURL() {
      return aircraftConfig.getAsset('handbook')
    },
    selectedProcedureStep(){
      return procedureTeacher.getStep();
    },
    settings(){
      return settings;
    }
  },
  data: () => ({
    tab: null,
    loadedRatio: 0,
    page: 1,
    numPages: 0,
    zoom: 100,
    initPage: 1
  }),
  mounted() {
    this.jumpToPage()
  },
  methods: {
    pdfError: function (err) {
      //ignored but spamming yolo
      // console.log('PDF Error', err);
    },
    jumpToPage() {
      if (this.procedure.handbook && this.initPage !== this.procedure.handbook) {
        this.initPage = Number(this.procedure.handbook);
        this.page = this.initPage;
      }
    },
    progress($event) {
      this.loadedRatio = $event
    }
  }
}
</script>

<style scoped lang="less">

.hardcodedHeightContainer{

}

.pdfviewer {
  display: inline-block;
  width: 100%;
}

.handbookwidthMinusTab{

  width: 47vw;
  @media screen and (max-width: 599px) {
    width: 97vw;
  }
  @media screen and (min-width: 600px) and (max-width: 1264px) {
    width: 67vw;
  }
}


</style>